export default "__VITE_ASSET__60139da8__"